<template>
    <q-layout view="hHh lpR fFf">
        <q-header class="bg-white text-black" style="border-bottom: 1px solid #e0e0e0">
            <q-toolbar style="justify-content: space-between; padding: 0 2vw">
                <div style="height: 7.17vmin; display: flex; align-items: center">
                    <q-icon name="img:/assets/images/icon/ico_back.svg" :onclick="onBack" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                    <div class="header_lesson q-px-sm b1">
                        <b>알림</b>
                    </div>
                </div>
                <div style="padding: 14px">
                    <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                </div>
            </q-toolbar>
        </q-header>
        <q-page-container>
            <StudyDetail v-if="isStudyDetail" :study="studyDetail" v-model:isStudyDetail="isStudyDetail" />
            <NoticeDetail v-if="isNoticeDetail" :seq="noticeSeq" v-model:isNoticeDetail="isNoticeDetail" />
            <q-page v-if="!isStudyDetail && !isNoticeDetail" style="padding: 5.33vmin 7vmin 3.33vmin; background-color: #fafafa">
                <div class="flex justify-between items-center">
                    <div class="btn__box" style="flex: 0 0 auto">
                        <CusButton :type="isStudy ? 570 : 580" :label="`학습알림`" @onReturn="onStudy" />
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <CusButton :type="!isStudy ? 570 : 580" :label="`공지사항`" @onReturn="onNotice" />
                    </div>

                    <!-- 셀렉트박스 -->
                    <div v-if="isStudy">
                        <div class="select__box" v-if="!isDisableStudySelect">
                            <CusSelect :li-list="optionsDate" v-model:current="wDate" @onReturn="onSelected" />
                        </div>
                        <div class="nodata_select_box" v-if="isDisableStudySelect">
                            <div>전체</div>
                            <img src="@/assets/images/icon/ico_down.svg" alt="down" />
                        </div>
                    </div>
                    <div v-if="!isStudy">
                        <div class="select__box" v-if="!isDisableNoticeSelect">
                            <CusSelect :li-list="optionsDate" v-model:current="wDate" @onReturn="onSelected" />
                        </div>
                        <div class="nodata_select_box" v-if="isDisableNoticeSelect">
                            <div>전체</div>
                            <img src="@/assets/images/icon/ico_down.svg" alt="down" />
                        </div>
                    </div>
                </div>
                <div style="position: relative">
                    <!-- 학습알림 -->
                    <div v-show="isStudy">
                        <q-infinite-scroll ref="refStudy" @load="getStudyList" :offset="600" class="caption" debounce="100">
                            <template v-for="(e, i) in studyList" :key="i">
                                <InformItemStudy :informData="e" @on-open="onItemStudy" />
                                <!-- bbbback -->
                            </template>
                            <template v-slot:loading>
                                <div class="row justify-center q-my-md">
                                    <q-spinner-dots color="primary" size="2vw" />
                                </div>
                            </template>
                        </q-infinite-scroll>
                    </div>
                    <div v-if="noDataStudy" class="noData__content">
                        <p class="null__content">
                            <img src="@/assets/images/icon/ico_contents_null.png" alt="none content" />
                        </p>
                        <NoData :message="`학습 알림이 없어요!`" :btnTitle="`학습 홈으로 이동`" />
                    </div>

                    <!-- 공지사항 -->
                    <div v-show="!isStudy">
                        <q-infinite-scroll ref="refNotice" @load="getNoticeList" :offset="600" class="caption" debounce="100">
                            <template v-for="(e, i) in noticeList" :key="i">
                                <InformItemNotice :informData="e" @on-open="onItemNotice" />
                            </template>
                            <template v-slot:loading>
                                <div class="row justify-center q-my-md">
                                    <q-spinner-dots color="primary" size="2vw" />
                                </div>
                            </template>
                        </q-infinite-scroll>
                    </div>
                    <div v-if="noDataNotice" class="noData__content">
                        <p class="null__content">
                            <img src="@/assets/images/icon/ico_contents_null.png" alt="none content" />
                        </p>
                        <NoData :message="`공지사항이 없어요!`" :btnTitle="`학습 홈으로 이동`" />
                    </div>
                </div>
            </q-page>
        </q-page-container>
    </q-layout>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import customHeader from '@/components/layouts/header/header.vue';
import { getStudyInformList, getNoticeList as getNoticeInformList, getNotice } from '@/api/modules/mypage.js';
import InformItemStudy from '@/views/myPage/components/informItemStudy.vue';
import InformItemNotice from '@/views/myPage/components/informItemNotice.vue';
import NoData from '@/views/userMap/components/noData.vue';
import CusSelect from '@/components/widget/CusSelect.vue';
import CusButton from '@/components/widget/CusButton.vue';
import StudyDetail from '@/views/myPage/inform/StudyDetail.vue';
import NoticeDetail from '@/views/myPage/inform/NoticeDetail.vue';
import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import { monitoringLog } from '@/api/modules/monitoring';

const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

const isDisableBtn = ref(false);
const isDisableSubmitBtn = ref(true);
const refStudy = ref(null);
const refNotice = ref(null);
const studyDetail = ref(null);
const noticeDetail = ref(null);

const isDisableStudySelect = computed(() => {
    return noDataStudy.value && isStudy.value && wDate.value.value === 'ALL';
});
const isDisableNoticeSelect = computed(() => {
    return noDataNotice.value && !isStudy.value && wDate.value.value === 'ALL';
});

const optionsDate = [
    { value: 'ALL', label: '전체' },
    { value: 'DAY_0', label: '오늘' },
    { value: 'DAY_3', label: '3일' },
    { value: 'DAY_7', label: '7일' },
];
const isStudy = ref(!gStore.is_notice_inform);
const isStudyDetail = ref(false);
// watch(isStudyDetail, (newData) => {
//     console.log('-watch-isStudyDetail--', newData);
// });
const isNoticeDetail = ref(false);
const noticeSeq = ref(0);

watch(isStudy, (isStudyNew, o) => {
    // noDataStudy.value = isStudy.value && studyList.value.length < 1;
    noDataStudy.value = false;
    noDataNotice.value = false;
    wDate.value = optionsDate[0];
    resetDataList(isStudyNew);
});
const studyList = ref([]);
const noDataStudy = ref(false);
let noMoreStudy = false;
const noticeList = ref([]);
const noDataNotice = ref(false);
let noMoreNotice = false;

const wDate = ref(optionsDate[0]);
watch(wDate, (nDate) => {
    noDataStudy.value = false;
    noDataNotice.value = false;
    resetDataList(isStudy.value);
});

const resetDataList = (_isStudy) => {
    if (_isStudy) {
        studyPageNo = 0;
        studyList.value = [];
        setTimeout(() => {
            refStudy.value?.resume();
        }, 500);
    } else {
        noticePageNo = 0;
        noticeList.value = [];
        setTimeout(() => {
            refNotice.value?.resume();
        }, 500);
    }
};

/////////////////////////--------학습알림--------//////////////////////////
let studyPageNo = 0;
const getStudyList = async (index, done) => {
    ++studyPageNo;
    const res = await getStudyInformList(gStore.token, studyPageNo, wDate.value.value);
    if (res) {
        if (res.status === 200) {
            const arrData = res.data.data;
            noMoreStudy = arrData.length === 0; // 더이상 없을때는 endless 중지
            studyList.value = [...studyList.value, ...arrData];
            done();
            noDataStudy.value = isStudy.value && studyList.value.length < 1;
        }
    }
    done(noMoreStudy);
    noDataStudy.value = isStudy.value && studyList.value.length < 1;
};

/////////////////////////--------공지사항--------//////////////////////////
let noticePageNo = 0;
const getNoticeList = async (index, done) => {
    ++noticePageNo;
    const res = await getNoticeInformList(noticePageNo, wDate.value.value);
    if (res) {
        if (res.status === 200) {
            const arrData = res.data.data;
            noMoreNotice = arrData.length === 0; // 더이상 없을때는 endless 중지
            noticeList.value = [...noticeList.value, ...arrData];
            done();
        }
    }
    done(noMoreNotice);
    noDataNotice.value = !isStudy.value && noticeList.value.length < 1;
};

////////////////////////////----OnClick----////////////////////////////
const onStudy = () => {
    isStudy.value = true;
};
const onNotice = () => {
    isStudy.value = false;
};

const onItemStudy = (obj) => {
    isStudyDetail.value = true;
    studyDetail.value = obj;
};

const onItemNotice = (obj) => {
    console.log('onItemNotice   obj', obj.seq);
    noticeSeq.value = obj.seq;
    isNoticeDetail.value = true;
};

const onSelected = (index) => {
    wDate.value = optionsDate[index];
};
const onBack = () => {
    if (isStudyDetail.value) isStudyDetail.value = false;
    else if (isNoticeDetail.value) isNoticeDetail.value = false;
    else router.push('/mypage');
};
const onHome = () => {
    dStore.openSelect('홈으로 이동하시겠습니까?', (val) => {
        val && router.push('/learninghome');
    });
};

onMounted(() => {
    if (gStore.is_notice_inform) {
        gStore.setIsNoticeInform(false);
        isStudy.value = false;
    }

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('inform monitoringLog API response ===', res);
    });
});
</script>

<style scoped lang="scss">
.bbbback {
    background-color: antiquewhite;
}

.icon-none {
    ::v-deep .q-field__append {
        display: none;
    }
}
/*
.normal {
    border: 1px solid black;
    border-radius: 40px;
    background-color: white;
    color: #123;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
}
*/

.hit {
    background-color: black;
    color: white;
}

//////// qqquasarDeep
::v-deep {
    input {
        //padding: 1.6vw;
        font-size: 1.2vw;
        color: $color_gray_900;
        line-height: 1.6vw;

        ::placeholder {
            color: $color_gray_600;
        }
    }

    .q {
        &-field {
            overflow: hidden;
            margin-top: 0px;
            &__control {
                align-items: center;
                height: 100%;
                border-radius: 1vmin;
                width: 11vw;
                //height: 3.2vw;
                min-height: inherit;
                padding: 0.92vmin 1.83vmin;
                text-align: center;
            }

            &__native {
                min-height: inherit;
                padding: 0;
                font-size: 1.2vw;
                line-height: 1.6vw;
                color: $color_gray_600;
            }

            &__label {
                top: 50%;
                left: 1.6vw;
                font-size: 1.2vw;
                color: $color_gray_600;
                line-height: 1.6vw;
                transform: translateY(-50%);
            }

            &--with-bottom {
                // padding-bottom: 3vmin;
                padding-bottom: 1.8vw;
            }

            &--float {
                .q-field__label {
                    top: 0.8vw;
                    font-size: 0.8vw;
                    @include transform(translateY(-40%));
                }
            }
        }
    }

    .q-field__control-container {
        align-items: center;
    }

    .q-field__marginal {
        width: 2.1vw;
        height: 2.1vw;
        padding-left: 0;
    }
    .q-select__dropdown-icon {
        width: 2.1vw;
        height: 2.1vw;
        text-indent: 9999rem;
        background: url('@/assets/images/icon/ico_down.svg') no-repeat center right/ contain;
    }
    .roundedBtnNormal {
        padding: 1.67vmin 3.33vmin;
        font-size: 1.2vw;
        line-height: 1.6vw;
        border: 1px solid $color_gray_900;
        @include border-radius(3vmin);

        &:nth-of-type(n + 2) {
            margin-left: 2vmin;
        }

        .q-btn__content {
            .block {
                font-weight: 700;
            }
        }
    }
    .roundedBtnNormal {
        color: $color_gray_900;
        background-color: #fafafa;

        &.roundedBtnHit {
            color: $color_white;
            background-color: $color_gray_900;
        }
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.noData__content {
    margin-top: 9.5vmin;
}

.null__content {
    width: 10%;
    max-width: 180px;
    margin: 0 auto;
    line-height: 0;

    img {
        width: 100%;
    }
}

.nodata_select_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 11vw;
    height: 3.2vw;
    border-radius: 1.5vmin;
    background-color: $color_gray_400;
    color: $color_gray_500;
    font-size: 1.2vw;
    line-height: 1.6vw;
    font-weight: 500;
    padding: 0.92vmin 1.83vmin;
    text-align: center;
    margin-left: 1.6vw;

    img {
        width: 2.1vw;
        height: 2.1vw;
        margin-left: 0.8vw;
    }
    div {
        margin-left: 10px;
    }
}
</style>
